export const getFillColor = (score: number) => {
  if (score <= 30) return 'high'
  if (score > 30 && score <= 60) return 'medium'
  return 'low'
}
